/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  ImportPriceApplyItemDto,
  ImportPriceBatchIdDto,
  ImportPriceFileItemDto,
  ImportPriceItemsCountDto,
} from '@gh/builder-shared-data';
import { map, omit } from 'lodash';

export type ImportPriceNewItem = ImportPriceFileItemDto;
export type ImportPriceFileItem = ImportPriceFileItemDto;
export type ImportPriceBatchId = ImportPriceBatchIdDto;
export type ImportPriceApplyItem = ImportPriceApplyItemDto;
export type ImportPriceItemsCount = ImportPriceItemsCountDto;

export const createApplyItems = (status: string) => (items: ImportPriceFileItem[]): ImportPriceApplyItem[] =>
  map(items, createApplyItem(status));

const createApplyItem = (status: string) => (item: ImportPriceFileItemDto) => <ImportPriceApplyItem>({
  ...item,
  uomId: item.uomId || void 0,
  isSalesTax: void 0,
  status,
});

export const omitApplyItem = (item: ImportPriceApplyItem): ImportPriceApplyItem =>
  <ImportPriceApplyItem>omit(
    item,
    ['cost', 'currentCost', 'batchRowNumber', 'variance', 'variancePct', 'isUp', 'errorCodes', 'version']);
